import { render, staticRenderFns } from "./personal-info-form.vue?vue&type=template&id=3f615e54&scoped=true&"
import script from "./personal-info-form.vue?vue&type=script&lang=js&"
export * from "./personal-info-form.vue?vue&type=script&lang=js&"
import style0 from "./personal-info-form.vue?vue&type=style&index=0&id=3f615e54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f615e54",
  null
  
)

export default component.exports